module.exports = __webpack_public_path__ + "/images/cover-cta-icons.22f7d9d.svg";